// src/components/shared/MultiFileSelectButton.jsx
// Auswahl mehrerer, gezielt einzeln markierter Rechnungsdateien aus einem Verzeichnis (im
// Unterschied zu DirectorySelectButton, das den gesamten Ordnerinhalt liefert). Für die
// Stapelverarbeitung im RechnungTab (PC-Ansicht).
import React, { useRef } from 'react'

const ACCEPT = '.pdf,.png,.jpg,.jpeg,.bmp'

function MultiFileSelectButton ({ onFilesSelected, disabled, className = '' }) {
  const inputRef = useRef(null)

  const handleClick = () => {
    inputRef.current?.click()
  }

  const handleChange = e => {
    const dateien = Array.from(e.target.files || [])
    if (dateien.length > 0) onFilesSelected(dateien)
    e.target.value = '' // erlaubt erneutes Auswählen derselben Dateien
  }

  return (
    <>
      <button
        type='button'
        className={`btn ${className}`.trim()}
        onClick={handleClick}
        disabled={disabled}
      >
        🗂 Mehrere Rechnungen auswählen
      </button>
      <input
        ref={inputRef}
        type='file'
        accept={ACCEPT}
        multiple
        style={{ display: 'none' }}
        onChange={handleChange}
      />
    </>
  )
}

export default MultiFileSelectButton
